var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileHolistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "url(#pattern0_332_2517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_332_2517",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_332_2517",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_332_2517",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACzklEQVR4nO2cTW4TMRiGZwV3KDfgALXFCVoWcA9ouQvr2hVrDlLKopQTpBK0C1jFDlkP8hQhlP6ISJnxPK+/V/IqUvI8eb9JR43jrrNYLBaLxWKxVEj//uBpiu5dDv48B/8rR9/vdJXnDP58eeKP+o/Pn5jfI1l/8M9S8F93XsIDKwV3WV5zqlJQfsOVMSHsX+jovkxxpeD8ho+piWHzn7WK+29HaYHsl6P7XAs4R/9plBbIfjm6VT1gtxqlBbJfxenpyxqlBbIfDljdDwes7ocDVvfDAav74YDV/XDA6n44YHW/2sD5f1fwVym6w03+dOpelseq8zVXSBz+i3p9p5Dgv9XmskL+iRVSb9oWyxN/cKeQ6A7LY7WvhIdWt21wwOp+OGB1Pxywuh8OWN0PB6zuhwNW98MBq/vhgNX9qm4CCD5tDazuN2wdrTZB7myUFsh+y+CP602QezNKC2S/262W7rIC7MV0W0lhfrebkSeEDu5iHV7s7fzdV/IrbZafCpTPvXH+EJbndGflMu5r/BxB1W8TpBNNpnhiQFvxxIC24okBbcVzY4fHohNNphRSvsNO0X8v677vuFWSKYW0kmyFzCtWyMxihcwsmELy6f7rFNzPFNyPFNyrTjSZcjeZort5bK+tShLlbhJzKbcSK2RmsUJmFitkZmmlkEy5m2ylkES5m2ylkEzxxIC24okBbcUTA9qKJwa0lVNXiYWsSaeSqk9QTzuVFDtBqqeSIidI+VRS3ASxTiXN+hO0ZSq6DYs2QautgfULgQGr++GA1f1wwOp+OGB1Pxywuh8OWN0PB6zuhwNW96sNnMXO6dUtJDLP6bVCYv03vZVCFsRzevGFdCMH54cDVvfDAav74YDV/XDA6n44YHU/HLD8qaTqhQTYqaS4bTLqp5LiJkj9VFLcBKmfSoqboBZOJUVNUCtBTZDFYrFYLBaLxdLdl98KbuKnKiKWGwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHolistic);
export default __webpack_public_path__ + "static/media/mobileHolistic.553a2191dfcfb2beca4ce7b4b5471d1f.svg";
export { ForwardRef as ReactComponent };